import { Routes, Route, Navigate } from "react-router-dom";
import { TopNav } from "./components/TopNav";
import { AuthProvider } from "./lib/auth";
import { DashboardPage } from "./pages/DashboardPage";
import { CrawlMapPage } from "./pages/CrawlMapPage";
import { CrawlRunPage } from "./pages/CrawlRunPage";
import { IntentTreePage } from "./pages/IntentTreePage";
import { TestGeneratorPage } from "./pages/TestGeneratorPage";
import { SignInPage } from "./pages/SignInPage";
import { AccountPage } from "./pages/AccountPage";
import { SchedulesPage } from "./pages/SchedulesPage";
import { RunsPage } from "./pages/RunsPage";
import { NotificationsPage } from "./pages/NotificationsPage";
import { TracesPage } from "./pages/TracesPage";
import { TraceViewerPage } from "./pages/TraceViewerPage";
import { HealsPage } from "./pages/HealsPage";
import { HealReviewPage } from "./pages/HealReviewPage";
import { CoveragePage } from "./pages/CoveragePage";
import { AuditLogPage } from "./pages/AuditLogPage";
import { AdminSsoPage } from "./pages/AdminSsoPage";
import { TermsPage } from "./pages/TermsPage";
import { PrivacyPage } from "./pages/PrivacyPage";

export function App(): JSX.Element {
  return (
    <AuthProvider>
      <div className="min-h-screen grid-lines">
        <TopNav />
        <main className="mx-auto max-w-7xl px-6 py-8">
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/crawls/new" element={<CrawlRunPage />} />
            <Route path="/crawls/:id" element={<CrawlMapPage />} />
            <Route path="/crawls/:id/intents" element={<IntentTreePage />} />
            <Route path="/crawls/:id/tests" element={<TestGeneratorPage />} />
            <Route path="/sign-in" element={<SignInPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/schedules" element={<SchedulesPage />} />
            <Route path="/runs" element={<RunsPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/traces" element={<TracesPage />} />
            <Route path="/runs/:id/trace" element={<TraceViewerPage />} />
            {/* Public, no-auth route for shared trace tokens. Uses the same
             *  TraceViewerPage in `mode="public"` — share button is hidden,
             *  data is loaded via /api/public/traces/:token. */}
            <Route
              path="/public/traces/:token"
              element={<TraceViewerPage mode="public" />}
            />
            <Route path="/heals" element={<HealsPage />} />
            <Route path="/heals/:id" element={<HealReviewPage />} />
            <Route path="/coverage" element={<CoveragePage />} />
            <Route path="/projects/:id/coverage" element={<CoveragePage />} />
            <Route path="/audit-log" element={<AuditLogPage />} />
            <Route path="/admin/sso" element={<AdminSsoPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </AuthProvider>
  );
}
